import {
    START_LOADING,
    END_LOADING,
    FETCH_ACCOUNT_SETTINGS,
    UPDATE_ACCOUNT_SETTINGS,
    ACCOUNT_SETTINGS_ERROR
} from "../actions/constants";

const initialState = {
    isLoading: false,
    accountSettings: {},
    error: null,
};

const accountSettings = (state = initialState, action) => {
    switch (action.type) {
        case START_LOADING:
            return { ...state, isLoading: true, error: null };
        case END_LOADING:
            return { ...state, isLoading: false };
        case FETCH_ACCOUNT_SETTINGS:
            return { ...state, accountSettings: action.payload };
        case UPDATE_ACCOUNT_SETTINGS:
            return { ...state, accountSettings: action.payload };
        case ACCOUNT_SETTINGS_ERROR:
            return { ...state, error: action.payload };
        default:
            return state;
    }
};

export default accountSettings;